import API_URL from "../config/config";

export const USER_UPDATED_EVENT = "instaport:user-updated";

const SESSION_KEYS = [
  "token",
  "userId",
  "userName",
  "userVerified",
  "userWallet",
  "userPhone",
  "userPoints",
];

const toSafeNumber = (value) => {
  const parsedValue = Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : 0;
};

const dispatchUserUpdate = (detail = null) => {
  if (typeof window === "undefined") {
    return;
  }

  window.dispatchEvent(new CustomEvent(USER_UPDATED_EVENT, { detail }));
};

export const formatCurrency = (amount, maximumFractionDigits = 0) =>
  new Intl.NumberFormat("en-IN", {
    style: "currency",
    currency: "INR",
    minimumFractionDigits: 0,
    maximumFractionDigits,
  }).format(toSafeNumber(amount));

export const getStoredUserName = () =>
  localStorage.getItem("userName") || "User";

export const getStoredUserId = () =>
  localStorage.getItem("userId") || "";

export const getStoredUserWallet = () =>
  toSafeNumber(localStorage.getItem("userWallet"));

export const getStoredUserPhone = () =>
  localStorage.getItem("userPhone") || "";

export const getStoredUserPoints = () =>
  toSafeNumber(localStorage.getItem("userPoints"));

export const persistSessionUser = (user = {}) => {
  if (user._id !== undefined) {
    localStorage.setItem("userId", user._id || "");
  }

  if (user.fullname !== undefined) {
    localStorage.setItem("userName", user.fullname || "User");
  }

  if (user.verified !== undefined) {
    localStorage.setItem("userVerified", user.verified ? "true" : "false");
  }

  if (user.wallet !== undefined) {
    localStorage.setItem("userWallet", String(toSafeNumber(user.wallet)));
  }

  if (user.mobileno !== undefined) {
    localStorage.setItem("userPhone", user.mobileno || "");
  }

  if (user.points !== undefined) {
    localStorage.setItem("userPoints", String(toSafeNumber(user.points)));
  }

  dispatchUserUpdate(user);
};

export const clearSessionData = () => {
  SESSION_KEYS.forEach((key) => {
    localStorage.removeItem(key);
  });

  dispatchUserUpdate(null);
};

export const syncSessionUser = async (
  token = localStorage.getItem("token")
) => {
  if (!token) {
    throw new Error("No active token found");
  }

  const response = await fetch(`${API_URL}/user`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
  });

  let responseData = null;
  try {
    responseData = await response.json();
  } catch (error) {
    responseData = null;
  }

  if (!response.ok || responseData?.error) {
    const requestError = new Error(
      responseData?.message || "Unable to fetch user information"
    );
    requestError.status = response.status;
    throw requestError;
  }

  const user = responseData?.user || responseData;
  persistSessionUser(user);
  return user;
};
